module.exports = __webpack_public_path__ + "img/yellow-green-sticker.c6a848f.gif";